import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Checkbox, FormControlLabel } from '@mui/material';
import { signInWithGoogle } from '../services/authService';
import { useNavigate } from 'react-router-dom';
import LandingPage from '../components/LandingPage';

const LoginPage = () => {

  const [open, setOpen] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // On mount, check if already authenticated
  useEffect(() => {
    const user = window.firebaseAuth ? window.firebaseAuth.currentUser : null;
    // Fallback: import auth directly if not on window
    let firebaseUser = user;
    try {
      if (!firebaseUser) {
        const { auth } = require('../firebase-config');
        firebaseUser = auth.currentUser;
      }
    } catch (e) { }
    const idToken = localStorage.getItem('firebaseIdToken');
    const accessToken = localStorage.getItem('googleAccessToken');
    if (firebaseUser && idToken && accessToken) {
      // Already authenticated, redirect
      navigate('/dashboard');
    }
  }, [navigate]);

  const handleLogin = () => {
    setOpen(true);
  };

  const handleConfirm = async () => {
    setOpen(false);
    setLoading(true);

    try {
      const { user, idToken, accessToken, refreshToken, isNewUser } = await signInWithGoogle();

      // Store tokens
      localStorage.setItem('firebaseIdToken', idToken);
      localStorage.setItem('googleAccessToken', accessToken);
      localStorage.setItem('googleRefreshToken', refreshToken);

      console.log(isNewUser ? '🎉 Welcome! Account created for:' : '👋 Welcome back:', user.email);

      // Redirect to dashboard
      navigate('/dashboard');
    } catch (error) {
      console.error('Login failed:', error);

      // User-friendly error messages
      if (error.code === 'auth/popup-closed-by-user') {
        alert('Sign-in cancelled. Please try again.');
      } else if (error.code === 'auth/popup-blocked') {
        alert('Pop-up was blocked. Please allow pop-ups for this site.');
      } else {
        alert('Failed to sign in. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <LandingPage handleLogin={handleLogin} />

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Trust this computer?</DialogTitle>
        <DialogContent>
          <FormControlLabel
            control={<Checkbox checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />}
            label="Trust this computer and remember for next time"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirm} color="primary" variant="contained">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default LoginPage;